import { create } from 'zustand';
import type { PositionStaffingDragPayload } from '../services/positionStaffingDrop';

interface PositionStaffingDragState {
  payload: PositionStaffingDragPayload | null;
  pointerId: number | string | null;
  origin: { x: number; y: number } | null;
  pointer: { x: number; y: number } | null;
  hoveredPositionId: string | null;
  hoveredValidity: 'valid' | 'invalid' | 'noop' | null;
  interactionLocked: boolean;
  begin(payload: PositionStaffingDragPayload, point: { x: number; y: number }, pointerId?: number | string): void;
  move(pointerId: number | string, point: { x: number; y: number }, hoveredPositionId: string | null, validity?: 'valid' | 'invalid' | 'noop' | null): void;
  setInteractionLocked(locked: boolean): void;
  clear(pointerId?: number | string): void;
}

/** Ephemeral opaque drag state. Labels and protected attributes are never persisted. */
export const usePositionStaffingDragStore = create<PositionStaffingDragState>((set) => ({
  payload: null,
  pointerId: null,
  origin: null,
  pointer: null,
  hoveredPositionId: null,
  hoveredValidity: null,
  interactionLocked: false,
  begin: (payload, point, pointerId = 'mouse') => set((state) => state.interactionLocked
    ? state
    : { payload, pointerId, origin: point, pointer: point, hoveredPositionId: null, hoveredValidity: null }),
  move: (pointerId, pointer, hoveredPositionId, hoveredValidity = null) => set((state) => (
    state.pointerId === pointerId ? { pointer, hoveredPositionId, hoveredValidity } : state
  )),
  setInteractionLocked: (interactionLocked) => set(interactionLocked
    ? { interactionLocked, payload: null, pointerId: null, origin: null, pointer: null, hoveredPositionId: null, hoveredValidity: null }
    : { interactionLocked }),
  clear: (pointerId) => set((state) => pointerId == null || state.pointerId === pointerId
    ? { payload: null, pointerId: null, origin: null, pointer: null, hoveredPositionId: null, hoveredValidity: null }
    : state),
}));
